/* eslint-disable */
import AuthService from "./AuthService";

export default new AuthService();



// WEBPACK FOOTER //
// ./src/auth/initAuth.js